import { ThemedIcon } from "@src/common/ThemedIcon";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Card } from "@uhg-abyss/web/ui/Card";
import { Heading } from "@uhg-abyss/web/ui/Heading";
import { Text } from "@uhg-abyss/web/ui/Text";
import type { ReactNode } from "react";

const FormSpacing = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "$web.semantic.spacing.scale.sm",
});

const NotFoundCardRoot = styled(Card, {
  width: "100%",
  padding: "2rem",
});

interface NotFoundCardProps {
  isMobile: boolean;
  headingText?: ReactNode;
  bodyText?: ReactNode;
}

export const NotFoundCard = ({
  isMobile,
  headingText = "404 - Page Not Found",
  bodyText = "Sorry, the page you are looking for does not exist or has been moved.",
}: NotFoundCardProps) => {
  return (
    <NotFoundCardRoot className={isMobile ? "v2card-form-mobile-style" : ""}>
      <FormSpacing>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "32px",
          }}
        >
          <ThemedIcon
            themeIconName="magnifying_glass_twotonedarkcircle"
            iconBrandProps={{
              icon: "magnifying_glass",
              size: 72,
              brand: "uhc",
              style: { marginBottom: "24px" },
            }}
            themedIconStyle={{ marginBottom: "24px" }}
          />
          <Heading
            size="md"
            css={{
              "abyss-heading-root": {
                marginBottom: "12px",
                textAlign: "center",
                width: "100%",
              },
            }}
          >
            {headingText}
          </Heading>
          <Text style={{ color: "$app.color.text.secondary", textAlign: "center" }}>
            {bodyText}
          </Text>
        </div>
      </FormSpacing>
    </NotFoundCardRoot>
  );
};
